import React, { useEffect, useState } from 'react';
import { Dialog, Select } from '@alifd/next';
import { Box, Typography } from '@mui/material';
import { Line } from '@ant-design/plots';
import axios from 'axios';
import { useSelector } from 'react-redux';

export default function ChartDialog({ visible, setVisible, currentCharacter }) {
  const [chartType, setChartType] = useState('month');
  const [service, setService] = useState('all');
  const [chartData, setChartData] = useState([
    {
      time: '',
      averageScores: 0,
      rank: '',
    },
  ]);

  const serviceData = useSelector((state) => state.service.serviceData);

  useEffect(() => {
    if (!visible) {
      setChartData([
        {
          time: '',
          averageScores: 0,
          rank: '',
        },
      ]);
      setService('all');
      setChartType('month');
    }
  }, [visible]);

  useEffect(() => {
    if (visible) {
      (async () => {
        try {
          const data = (
            await axios.get('/ezcon/api/getQuestionnaireAnswerChartData', {
              params: {
                ratingObjectTable: currentCharacter.ratingObjectTable,
                ratingObjectId: currentCharacter.ratingObjectId,
                service,
                chartType,
              },
              headers: {
                authorization: localStorage.getItem('feathers-jwt'),
              },
            })
          ).data;
          setChartData(data);
        } catch (e) {
          console.error(e);
        }
      })();
    }
  }, [chartType, currentCharacter, service, visible]);

  const Card = ({ title, children }) => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '500px',
        width: '600px',
      }}
    >
      <Typography variant="h6">{title}</Typography>
      {children}
    </Box>
  );

  return (
    <Dialog visible={visible} footer={false} onClose={() => setVisible(false)}>
      <Box>
        <Card title="滿意度變化圖">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '1rem',
            }}
          >
            <Select value={service} onChange={(val) => setService(val)}>
              <Select.Option value="all">全部</Select.Option>
              {currentCharacter.service.map((i) => {
                const name =
                  serviceData.data.find((item) => item.id === i).name || '';
                return (
                  <Select.Option key={i} value={i}>
                    {name}
                  </Select.Option>
                );
              })}
            </Select>
            <Select value={chartType} onChange={(val) => setChartType(val)}>
              <Select.Option value="month">月</Select.Option>
              <Select.Option value="year">年</Select.Option>
            </Select>
          </Box>
          <Box
            sx={{
              height: '400px',
              width: '600px',
            }}
          >
            <Line
              data={chartData}
              xField="time"
              yField="averageScores"
              yAxis={{
                label: {
                  formatter: (val) => `${val}%`,
                },
              }}
              height={400}
              width={600}
              tooltip={{
                customContent: (title, data) => {
                  const statistic = data[0]?.data || {
                    time: '',
                    averageScores: 0,
                    rank: '',
                  };
                  return (
                    <Box>
                      <Typography variant="h6">{title}</Typography>
                      <Box>
                        <Typography variant="body1">{`評等：${statistic.rank}`}</Typography>
                        <Typography variant="body1">{`滿意度：${statistic.averageScores} %`}</Typography>
                      </Box>
                    </Box>
                  );
                },
              }}
              point={{
                shape: 'circle',
              }}
            />
          </Box>
        </Card>
      </Box>
    </Dialog>
  );
}
